// extracted by mini-css-extract-plugin
export default {"container":"BuildChangeMonitor_container__RJrWX","reloadPageButton":"BuildChangeMonitor_reloadPageButton__T20E8"};